import styled from 'styled-components';
import { Button } from '@core/ui';

export const Info = styled('div')`
  margin-top: ${({ theme: { spacing } }) => spacing(6)};
`;

export const Back = styled(Button)`
  margin-top: ${({ theme: { spacing } }) => spacing(13)};
  margin-bottom: ${({ theme: { spacing } }) => spacing(9)};
`;
